
import { getRole, getuserCurrentApp, getuserCurrentAppName, getuserWorkCode } from '@/utils/cookies'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import { UserModule } from '@/store/modules/user'
import { ORDERAPI } from '@/api/orders'
import detailEvents from '@/views/Ticket/components/detailEvents.vue'
import { formateTicketType, formateTicketStatus, ITicketsBtn, getBtnClass } from '@/utils/tickets'
import { isItTicketType, isNetworkTicketType, isLiveType, isAdministrationTicketType } from '@/utils/commonFunc'
import { problemList } from '@/utils/consts'
import YachChat from '@/views/components/yachChat.vue'
import { platformV2 } from 'yach.open.jssdk'
import { getAppid } from '@/utils/utils'
import { isAgentMobile } from '@/utils/validate'
import { AppModule, DeviceType } from '@/store/modules/app'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
@Component({
  name: 'detailContent',
  methods: { getAppid },
  components: {
    detailEvents,
    YachChat
  }
})

export default class extends Vue {
  @Prop({ default: false }) private isManager!: boolean // 是否为保障人员(处理)权限
  @Prop({ default: false }) private isItTicket!: boolean // 是否为IT工单类型
  @Prop({ default: false }) private editForm!: any // 编辑表单时用到的表单数据

  // 引用 viewerContainer 容器
  private viewerContainer: HTMLElement | null = null;
  // private viewer: Viewer | null = null;

  private currentTicket = TicketsModule.defaultTicket
  private isAcceptCurrentUser = false
  private isCreateCurrentUser = false
  private ticketType = '' // 工单类型
  private ticketStatus = {} // 工单状态
  private sizeName = window.innerWidth > 800 ? '' : 'small' // el-button 按钮大小
  private btnObj: ITicketsBtn = { // 按钮是否显示
    edit: false,
    hurry: false,
    cancel: false,
    accept: false,
    reject: false,
    forward: false,
    pending: false,
    unpending: false,
    finish: false,
    rate: false,
    close: false,
    className: 'fixed-full-btn', // 按钮样式名称
    isCompleted: false
  }

  private srclist: any = []
  private isDetailPage = this.$route.name === 'orderDetailIndex' // 是否访问的是工单详情页
  private scrollHeight = '' // 滚动区高度

  private issueTypeOptions = [] // 问题类型options
  formData = {
    issue_type: [] as any
  }

  // 判断 URL 是否是图片格式
  isImage(url: string): boolean {
    return /\.(jpeg|jpg|png|gif|bmp)$/i.test(url) // 判断是否以图片格式结尾
  }

  handleIssueTypeChange(value: any) {
    const postData = {
      ticket_number: this.currentTicket.ticket_number,
      issue_type: this.formData.issue_type[1],
      t_type: value.ticket_type
    }
    ORDERAPI.updateTicket(postData, { app_id: this.userCurrentApp })
      .then((res: any) => {
        this.$emit('handleSuccess', res)
        // this.handleClose()
        // 更新成功后刷新当前页
        this.$router.go(10)
      }).catch(() => {
        console.log('update success')
      })
  }

  handleImageError({ event }: { event: any }) {
    // 当图片加载失败时显示提示
    event.target.src = '' // 设置占位符图片路径
  }

  get isAgentMobile() {
    return isAgentMobile()
  }

  get device() {
    return AppModule.device
  }

  get isMobile() {
    return this.device === DeviceType.Mobile
  }

  get currentWorkcode() {
    return getuserWorkCode()
  }

  get isItTicketType() {
    return isItTicketType()
  }

  get isLiveType() {
    return isLiveType()
  }

  get isNetworkTicketType() {
    return isNetworkTicketType()
  }

  get isAdministrationTicketType() {
    return isAdministrationTicketType()
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get userGetuserCurrentAppName() {
    return getuserCurrentAppName()
  }

  // 角色
  get ROLE() {
    return Number(UserModule.roles || getRole() || 1)
  }

  get isDisabled() {
    return this.ROLE < 4
  }

  get currentListTicket() {
    return TicketsModule.currentTicket || {}
  }

  // 正在操作的工单index
  get ticketIndex() {
    return TicketsModule.currentTicketIndex || 0
  }

  get problemList() {
    return problemList
  }

  get inYach() {
    return platformV2.inYach
  }

  // initViewer() {
  //
  //   this.viewerContainer = this.$refs.viewerContainer as HTMLElement
  //   if (this.viewerContainer) {
  //     this.viewer = new Viewer(this.viewerContainer, {
  //       inline: false, // 确保在移动端以全屏模式显示
  //       toolbar: true, // 显示工具栏
  //       navbar: true, // 显示导航条
  //       title: false, // 是否显示图片标题
  //       movable: true, // 允许移动图片
  //       rotatable: true, // 允许旋转图片
  //       scalable: true, // 允许放大缩小
  //       zoomable: true, // 允许缩放
  //     })
  //     this.viewer.update()
  //     console.log('this.viewerContainer====>>>',this.viewerContainer)
  //     console.log('22222---->>>>',this.currentTicket.remark)
  //     console.log('this.viewer====>>>',this.viewer)
  //   }
  // }

  // ticket改变时，重新判断是否有操作按钮权限
  @Watch('currentListTicket')
  private onTicketChange(value: number) {
    this.currentTicket = this.currentListTicket
    this.getBtnStatus()
  }

  // 受理人改变时，重新判断是否有操作按钮权限
  @Watch('currentTicket.accept_user.workcode')
  private onTicketStatusChange(value: number) {
    this.isAcceptCurrentUser = this.setIsAcceptCurrentUser()
    this.getBtnStatus()
  }

  // @Watch('srclist')
  // private onTicketRemarkLoad(value: number) {
  //   console.log('22222=====>>',this.srclist)
  //   this.initViewer()
  // }

  // 计算滚动区高度
  @Watch('sizeName')
  private calcScrollHeight() {
    let h = this.sizeName === 'small' ? 215 : 225
    if (this.isDetailPage) {
      // navbar高度
      h += 50
    }
    // 详情页无显示按钮的状态
    if (this.isDetailPage && [3, 4, 5].includes(this.currentTicket.status)) {
      h -= 44
    }
    this.scrollHeight = `calc(100vh - ${h}px)`
  }

  // compat setRole function delay
  @Watch('ROLE')
  private watchROLE(newVal: any, oldVal: any) {
    if (newVal > 1) {
      this.getBtnStatus()
    }
  }

  mounted() {
    const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
    this.getIssueType()
    window.addEventListener(resizeEvt, () => {
      this.sizeName = window.innerWidth > 800 ? '' : 'small'
    }, false)
    this.assignFormdata()
    // nextTick(() => {
    //   this.initViewer()
    // })
    // window.onload = () => {
    //   this.initViewer()
    // }
    // 初始化 Viewer.js 实例
    // this.viewerContainer = this.$refs.viewerContainer as HTMLElement
    //
    // if (this.viewerContainer) {
    //   this.viewer = new Viewer(this.viewerContainer, {
    //     inline: false, // 确保在移动端以全屏模式显示
    //     toolbar: true, // 显示工具栏
    //     navbar: true, // 显示导航条
    //     title: false, // 是否显示图片标题
    //     movable: true, // 允许移动图片
    //     rotatable: true, // 允许旋转图片
    //     scalable: true, // 允许放大缩小
    //     zoomable: true, // 允许缩放
    //   })
    // }
  }

  // beforeDestroy() {
  //   // 销毁 Viewer 实例
  //   if (this.viewer) {
  //     this.viewer.destroy()
  //     this.viewer = null
  //   }
  // }

  assignFormdata() {
    const editIssueType: any = [this.currentTicket.issue_type.pid, this.currentTicket.issue_type.id]
    this.formData = {
      issue_type: editIssueType
    }
  }

  private async getIssueType() {
    const options = ConfigModule.issueTypeOptions
    if (options.length <= 0) { // 仅首次打开时请求
      const { data } = await CONFIGAPI.getIssuesType({ app_id: this.userCurrentApp })
      const newData: any = []
      // 删掉掉没有基地的地区
      data.map((item: any) => {
        if (item.children && item.children.length !== 0) {
          newData.push(item)
        }
      })
      this.issueTypeOptions = newData
      ConfigModule.setIssueTypeOptions(newData)
    } else {
      this.issueTypeOptions = options
    }
  }

  created() {
    if (this.isDetailPage) { // 详情页
      this.handleDetail(this.$route.params.tid, this.$route.params.ticketType)
    } else { // 弹框
      this.currentTicket = this.currentListTicket
      this.isAcceptCurrentUser = this.setIsAcceptCurrentUser()
      this.isCreateCurrentUser = this.setIsCreateCurrentUser()
      this.srclist.push(this.currentTicket.remark)
      if (getRole()) {
        this.getBtnStatus()
      }
      this.calcScrollHeight()
    }
  }

  // 获取按钮显示及样式
  getBtnStatus() {
    let userType = 0
    if (this.isManager) {
      userType = this.isManager ? 2 : 1
    } else {
      // eslint-disable-next-line no-unused-expressions
      this.ROLE > 1 ? 2 : 1
    }
    this.btnObj = getBtnClass(this.currentTicket, this.isCreateCurrentUser, this.isAcceptCurrentUser, userType, !this.isDetailPage)
    if (this.currentTicket.live_ticket_type === 2) {
      this.btnObj.className = 'fixed-full-btn'
    }
    if (this.btnObj.rate && this.ROLE !== 4) {
      this.btnObj.rate = false
      this.btnObj.className = 'fixed-full-btn'
    }
    this.btnObj.isCompleted = true
  }

  // 工单类型
  private getTicketType(type: number) {
    this.ticketType = formateTicketType(type)
    return this.ticketType
  }

  // 工单状态
  private getTicketStatus(status: number, isForward: number) {
    const tStatus: any = formateTicketStatus(status, isForward)
    this.$set(this.ticketStatus, 'name', tStatus.name)
    this.$set(this.ticketStatus, 'class', tStatus.class)
    return this.ticketStatus
  }

  // 受理人 是否为当前用户
  private setIsAcceptCurrentUser() {
    const acceptUser = this.currentTicket.accept_user ? this.currentTicket.accept_user.account || '' : ''
    return acceptUser === UserModule.username
  }

  // 发起人 是否为当前用户
  private setIsCreateCurrentUser() {
    const creator = this.currentTicket.creator ? this.currentTicket.creator.account || '' : ''
    return creator === UserModule.username
  }

  // 工单挂起
  private handlePending(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'pendingDialog',
      value: true
    })
  }

  // 解除挂起
  private handleUnPending(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'unpendingDialog',
      value: true
    })
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'detailDialog',
      value: false
    })
  }

  // 编辑工单
  private handleEdit(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: 0 })
    TicketsModule.ToggleDialogStatus({
      name: 'editDialog',
      value: true
    })
  }

  // 撤销工单
  private handleCancel(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(`确定要撤销「${ticket.tid}」此工单吗？`, '撤销确认', {
      type: 'warning',
      roundButton: true,
      customClass: 'confirm-center',
      cancelButtonClass: 'dilog-width-btn',
      confirmButtonClass: 'dilog-width-btn'
    }).then(_ => {
      ORDERAPI.cancelTicket({
        tid: ticket.tid,
        t_type: ticket.ticket_type
      }).then((res) => {
        this.handleSuccess(res)
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {
      })
      // eslint-disable-next-line @typescript-eslint/no-empty-function
    }).catch(_ => {
    })
  }

  // 受理工单
  private handleAccept(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(`确定要受理 ${ticket.creator.name} 发起的「${ticket.tid}」工单吗？`, '受理确认', {
      type: 'warning',
      roundButton: true,
      customClass: 'confirm-center',
      cancelButtonClass: 'dilog-width-btn',
      confirmButtonClass: 'dilog-width-btn'
    })
      .then(_ => {
        ORDERAPI.acceptTicket({
          tid: ticket.tid,
          t_type: ticket.ticket_type
        }, {
          app_id: this.userCurrentApp
        }).then((res) => {
          this.handleSuccess(res)
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        }).catch(() => {
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(_ => {
      })
  }

  // 驳回工单
  private handleReject(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'rejectDialog',
      value: true
    })
  }

  // 完成工单
  private handleFinished(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'finishedDialog',
      value: true
    })
  }

  // 评价工单
  private handleRate(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'rateDialog',
      value: true
    })
  }

  // 转接工单
  private handleForward(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    TicketsModule.ToggleDialogStatus({
      name: 'forwardDialog',
      value: true
    })
  }

  // 催单
  private handleRemind(ticket: any) {
    TicketsModule.SetCurrentTicket({ ticket, ticketIndex: this.ticketIndex })
    this.$confirm(`确定要催促「${ticket.tid}」此工单？`, '催单确认', {
      type: 'warning',
      roundButton: true,
      customClass: 'confirm-center',
      cancelButtonClass: 'dilog-width-btn',
      confirmButtonClass: 'dilog-width-btn'
    })
      .then(_ => {
        ORDERAPI.remindTicket({
          tid: ticket.tid,
          t_type: ticket.ticket_type
        }).then((res) => {
          this.$message({
            message: res.data,
            type: 'success'
          })
          // eslint-disable-next-line @typescript-eslint/no-empty-function
        }).catch(() => {
        })
        // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(_ => {
      })
  }

  // 事件节点组件更新数据，也在父组件中详情更新后调用
  private handleEvents() {
    this.$refs.detailEvents && (this.$refs.detailEvents as any).handleEvents()
  }

  private handleSuccess(res: any) {
    if (res.stat) {
      this.$emit('handleSuccess', res)
    }
  }

  // 获取正在操作的工单详情
  private handleDetail(tid: string, ticketType: string) {
    const loading = this.$loading({
      lock: true,
      text: '加载中，请稍候',
      background: 'rgba(255, 255, 255, 0.75)'
    })
    ORDERAPI.detailTicket({
      tid: tid,
      ticket_type: ticketType,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        // 事件节点组件更新数据
        this.handleEvents()

        this.currentTicket = res.data
        this.isAcceptCurrentUser = this.setIsAcceptCurrentUser()
        this.isCreateCurrentUser = this.setIsCreateCurrentUser()
        this.btnObj = getBtnClass(res.data, this.isCreateCurrentUser, this.isAcceptCurrentUser)
        this.srclist.push(this.currentTicket.remark)
        console.log('srclist====>>>>>', this.srclist)
        // this.initViewer()
        // 存store，供功能弹框使用
        TicketsModule.SetCurrentTicket({ ticket: res.data })
        loading.close()

        // 设置滚动区高度
        this.calcScrollHeight()
      }
    }).catch(() => {
      loading.close()
    })
  }

  private clipboardSuccesssHandler() {
    (this as any).$toast('复制成功')
  }

  private clipboardErrorHandler() {
    (this as any).$toast('复制失败')
  }

  private handleYachChat(ticket: any) {
    (this.$refs.yachChat as any).onOpenSingleChat(ticket)
  }
}
